<div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto">
  <h1 class="display-4 text-center">Planes</h1>
  <p class="lead">
    Suscribite y disfrutá de toda tu pasión en un solo lugar. Goles, resúmenes, fechas pasadas y mucho más. (No incluye eventos en vivo).
  </p>
  <div *ngIf="this.error" [innerHTML]="this.error" class="errors-container mt-3 alert alert-danger" role="alert"></div>
  <div *ngIf="this.message" [innerHTML]="this.message" class="messages-container mt-3 alert alert-success" role="alert"></div>
</div>

<div class="containncyer">
  <div *ngIf="this.plans.length > 0" class="card-deck mb-3 text-center row">
    <div *ngFor="let plan of this.plans" class="card mb-4 box-shadow col-lg-4 col-md-6 col-xs-12">
      <div class="card-header">
        <h4 class="my-0 font-weight-normal">{{plan.PlanName}}</h4>
      </div>
      <div class="card-body">
        <h1 class="card-title pricing-card-title">
          ${{plan.PlanPrice}}
          <br>
          <!--<small class="text-muted">{{plan.PlanFrequency}}</small>-->
        </h1>
        <div class="mb-4" [innerHTML]="plan.PlanDescription"></div>
      </div>
      <div class="card-footer">
        <button *ngIf="!this.userIsLoggedIn() || !plan.LoggedInUserHasPlan" type="button" class="use-app-colors btn btn-lg btn-block btn-primary" (click)="this.subscribeToPlan(plan.PlanId)">Suscribirse</button>
        <span *ngIf="this.userIsLoggedIn() && plan.LoggedInUserHasPlan">Suscripto/a</span>
      </div>
    </div>
  </div>
</div>

<div style="display: inline-block; font-size: xx-small; position: fixed; bottom: 5px; right: 5px;">V{{this.version}} - {{this.environmentSettingsFile}}</div>
